{
  "file": {
    "byte": "byte",
    "bytes": "bytes",
    "kB": "kB",
    "MB": "MB",
    "GB": "GB",
    "TB": "TB"
  }
}
